import React, { useMemo } from 'react'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import CarCardAdditionalDetails from 'components/atoms/CarCardAdditionalDetails'
import CarCardAdditionalDetailsItem from 'components/atoms/CarCardAdditionalDetailsItem'

import { getAssignmentRecapValues } from '../Assignment/assignmentLib'

export default function CapManagementRecapValues({ cars }) {
  const { t } = useTranslation()

  const choices = useMemo(() => getAssignmentRecapValues(cars), [cars])

  return (
    <>
      <CarCardAdditionalDetails sx={{ mt: 0 }}>
        <CarCardAdditionalDetailsItem
          title={t('assignment.cap-management.titles.all')}
          value={choices.total || '-'}
        />
        <CarCardAdditionalDetailsItem
          title={t('assignment.cap-management.titles.firstChoice')}
          value={choices.firstChoice || '-'}
        />
        <CarCardAdditionalDetailsItem
          title={t('assignment.cap-management.titles.blind')}
          value={choices.blindOffers || '-'}
        />
        <CarCardAdditionalDetailsItem
          title={t('assignment.cap-management.titles.notChosen')}
          value={choices.notChosen || '-'}
        />
      </CarCardAdditionalDetails>
      <Box pr={2} />
      <CarCardAdditionalDetails sx={{ mt: 0 }}>
        <CarCardAdditionalDetailsItem
          title={t('assignment.cap-management.titles.automatic')}
          value={choices.automatic || '-'}
        />
        <CarCardAdditionalDetailsItem
          title={t('assignment.cap-management.titles.teamProposal')}
          value={choices.teamProposal || '-'}
        />
        <CarCardAdditionalDetailsItem
          title={t('assignment.cap-management.titles.noProposal')}
          value={choices.noProposal || '-'}
          valueProps={{ color: choices.noProposal ? 'error' : undefined }}
        />
        <CarCardAdditionalDetailsItem
          title={t('assignment.cap-management.titles.appealing')}
          value={choices.appealing ? `${choices.appealing}/7` : '-'}
        />
      </CarCardAdditionalDetails>
    </>
  )
}

CapManagementRecapValues.propTypes = {
  cars: T.array,
}
